import { baseApi } from './baseApi';

const TAG = 'SharedAccessLinks';

const sharedAccessLinksApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSharedAccessLinks: builder.query({
      query: () => ({
        url: '/shared-access-links/',
        method: 'GET',
      }),
      transformResponse: (response) => {
        // Handle different response formats
        if (Array.isArray(response)) {
          return response;
        }
        if (response?.results) {
          return response.results;
        }
        return [];
      },
      providesTags: [TAG],
    }),
    fetchSharedAccessLink: builder.query({
      query: ({ id }) => ({
        url: `/shared-access-links/${id}/`,
        method: 'GET',
      }),
      providesTags: (result, error, arg) => (result ? [{ type: TAG, id: arg.id }, TAG] : [TAG]),
    }),
    createSharedAccessLink: builder.mutation({
      query: (params) => ({
        url: '/shared-access-links/',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: [TAG],
    }),
    updateSharedAccessLink: builder.mutation({
      query: ({ id, ...params }) => ({
        url: `/shared-access-links/${id}/`,
        method: 'PATCH',
        body: params,
      }),
      invalidatesTags: (result, error, arg) => [TAG, { type: TAG, id: arg.id }],
    }),
    deactivateSharedAccessLink: builder.mutation({
      query: ({ id }) => ({
        url: `/shared-access-links/${id}/deactivate/`,
        method: 'POST',
        body: {},
      }),
      invalidatesTags: (result, error, arg) => [TAG, { type: TAG, id: arg.id }],
    }),
    deleteSharedAccessLink: builder.mutation({
      query: ({ id }) => ({
        url: `/shared-access-links/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAG],
    }),
    fetchSharedAccessLogs: builder.query({
      query: ({ id }) => ({
        url: `/shared-access-links/${id}/logs/`,
        method: 'GET',
      }),
      providesTags: (result, error, arg) => [{ type: TAG, id: arg.id }, TAG],
    }),
  }),
});

export const {
  useFetchSharedAccessLinksQuery,
  useLazyFetchSharedAccessLinksQuery,
  useFetchSharedAccessLinkQuery,
  useLazyFetchSharedAccessLinkQuery,
  useCreateSharedAccessLinkMutation,
  useUpdateSharedAccessLinkMutation,
  useDeactivateSharedAccessLinkMutation,
  useDeleteSharedAccessLinkMutation,
  useFetchSharedAccessLogsQuery,
  useLazyFetchSharedAccessLogsQuery,
} = sharedAccessLinksApi;

